import VideoEndingOverlay from './VideoEndingOverlay';

export default VideoEndingOverlay;
